import { Injectable } from '@angular/core'
import { areas, descriptionTranslation, Language, niveis, titleTranslation, unidadesTranslations } from '../models/translations.model'
import { Programa } from '../models/programa.model'

@Injectable({
  providedIn: 'root'
})
export class TranslationService {
  
  translateUnidade(originalName: string, language: string): string {
    const nameTranslations = unidadesTranslations[originalName]
    if (nameTranslations) {
      return nameTranslations[language as Language] || originalName
    } else {
      return originalName
    }
  }

  translateTitle(language: string): string {
    return titleTranslation[language as Language]
  }

  translateDescription(language: string): string {
    return descriptionTranslation[language as Language]
  }

  translateAreas(language: string): string[] {
    return areas[language as Language]
  }

  translateNiveis(language: string): string[] {
    return niveis[language as Language]
  }

  ajustaNiveisEnUs(programa: Programa) {
    for (let i = 0; i < programa.niveis.length; i++) {
      if (programa.niveis[i] === 'Master Professional') {
        programa.niveis[i] = 'Professional Master'
      }
      if (programa.niveis[i] === 'Doctorate Professional') {
        programa.niveis[i] = 'Professional Doctorate'
      }
    }
  }

}
